import React, { HTMLAttributes, useMemo } from 'react';
import { Form, FormControlProps } from 'react-bootstrap';

import cx from 'classnames';

interface ITextAreaWithCounterProps
  extends Omit<HTMLAttributes<HTMLElement>, 'onChange'> {
  formControlProps: FormControlProps;
  onChange: (value: string) => any;
  value: string;
  maxLength?: number;
}

const TextareaWithCounter: React.FC<ITextAreaWithCounterProps> = ({
  onChange,
  value,
  maxLength,
  formControlProps,
  className,
  ...props
}) => {
  const counter = useMemo(
    () => (maxLength || 0) - (value?.length || 0),
    [maxLength, value?.length],
  );

  return (
    <div className={cx(className, 'position-relative')} {...props}>
      {maxLength && (
        <small className="text-grey position-absolute bottom-0 right-0 mr-3 bg-white mb-1 caption no-pointer-events">
          {counter} characters left
        </small>
      )}
      <Form.Control
        {...formControlProps}
        maxLength={maxLength}
        as="textarea"
        rows={6}
        onChange={({ target: { value: newValue } }) => onChange(newValue)}
        value={value}
      />
    </div>
  );
};

export default TextareaWithCounter;
